import { useNavOwnerSync } from "@/hooks/useBackNav";

/**
 * PRODUCT_DEV-1043: ログインした人を来た画面の記録に結び付ける（描画はしない）。
 * RootLayout（root loader の内側）に 1 つ置く。違う人がログインしたら、前の人の記録
 * （商談名・顧客名などのタイトルが入る）を捨てる。
 */
export default function NavOwnerSync() {
  useNavOwnerSync();
  return null;
}
